// Arabic strings for the reports area. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  // Dashboard shell: personas and view switcher
  'Preview Role View': 'معاينة عرض الدور',
  'Your Role View': 'عرض دورك',
  'Viewing as:': 'العرض بصفة:',
  'Role view': 'عرض الدور',
  'Dashboard view': 'عرض لوحة المعلومات',
  'Finance Controller': 'المراقب المالي',
  Auditor: 'المدقق',
  'Auditor (Read-Only)': 'المدقق (قراءة فقط)',
  'Property Manager': 'مدير العقار',
  'Field User': 'المستخدم الميداني',
  Storekeeper: 'أمين المخزن',
  'Executive Analytics Hub': 'مركز التحليلات التنفيذية',
  'Fixed Asset Register (FAR) Report': 'تقرير سجل الأصول الثابتة (FAR)',
  'Loss & Breakage': 'الفقد والكسر',
  'Lifecycle Forecast': 'توقعات دورة الحياة',
  'Capex Forecast': 'توقعات النفقات الرأسمالية',
  'OE Cost per Occupied Room': 'تكلفة معدات التشغيل لكل غرفة مشغولة',
  '{currency} Currency': 'العملة {currency}',
  'Mixed currencies': 'عملات مختلطة',
  Currency: 'العملة',
  'The Fixed Asset Register report is available to the Finance Controller and the Auditor.': 'تقرير سجل الأصول الثابتة متاح للمراقب المالي والمدقق.',
  'Auditor Persona Active: Viewing read-only Fixed Asset Register compliance report and immutable ledger schedules.':
    'وضع المدقق مفعّل: عرض تقرير امتثال سجل الأصول الثابتة للقراءة فقط وجداول الدفاتر غير القابلة للتعديل.',
  'There is no closed period to export.': 'لا توجد فترة مغلقة للتصدير.',
  'Fixed Asset Register exported as {filename}.': 'تم تصدير سجل الأصول الثابتة باسم {filename}.',

  // Fixed Asset Register
  'IAS 16 Compliance': 'الامتثال لمعيار IAS 16',
  'Closed Period Register Reconciliation': 'تسوية السجل للفترة المغلقة',
  'Official Fixed Asset Register (FAR) Schedule': 'جدول سجل الأصول الثابتة (FAR) الرسمي',
  'Reconciles opening cost, additions, disposals, depreciation, and closing NBV across categories and USALI departments.':
    'يسوّي التكلفة الافتتاحية والإضافات والاستبعادات والإهلاك وصافي القيمة الدفترية الختامية عبر الفئات وأقسام USALI.',
  'Export FAR (XLSX)': 'تصدير السجل (XLSX)',
  'Export FAR (CSV)': 'تصدير السجل (CSV)',
  'Property Scope': 'نطاق العقار',
  'All Portfolio Properties': 'جميع عقارات المحفظة',
  'As-At Closed Period': 'كما في الفترة المغلقة',
  'No closed period': 'لا توجد فترة مغلقة',
  'Closed Run #{n}': 'تشغيل مغلق رقم {n}',
  '{n} Closed Runs': '{n} عمليات تشغيل مغلقة',
  'Grouping Dimension': 'بُعد التجميع',
  'By Category Class': 'حسب فئة الصنف',
  'By USALI Department': 'حسب قسم USALI',
  'By Location / Wing': 'حسب الموقع / الجناح',
  'Location / Wing': 'الموقع / الجناح',
  'USALI Department': 'قسم USALI',
  'Category Class': 'فئة الصنف',
  'No accounting period has been closed yet. Post a monthly Depreciation Run to produce the register as at that period.':
    'لم تُغلق أي فترة محاسبية بعد. رحِّل تشغيل إهلاك شهري لإصدار السجل كما في تلك الفترة.',
  'Cost Basis ({currency})': 'أساس التكلفة ({currency})',
  'Accumulated Depreciation ({currency})': 'الإهلاك المتراكم ({currency})',
  'Closing NBV ({currency})': 'صافي القيمة الدفترية الختامية ({currency})',
  'Other movements ({currency})': 'حركات أخرى ({currency})',
  Opening: 'الافتتاحي',
  '+ Additions': '+ الإضافات',
  '- Disposals': '- الاستبعادات',
  'Closing Cost': 'التكلفة الختامية',
  '+ Period Dep.': '+ إهلاك الفترة',
  '- Disposed': '- المستبعد',
  'Closing Accum': 'المتراكم الختامي',
  'Transfers - Cost': 'التحويلات - التكلفة',
  'Transfers - Acc. Dep.': 'التحويلات - الإهلاك المتراكم',
  'Accumulated Impairment': 'الانخفاض المتراكم في القيمة',
  'Exchange Difference': 'فرق الصرف',
  'Loading register...': 'جارٍ تحميل السجل...',
  'No assets on the register as at {period}.': 'لا توجد أصول في السجل كما في {period}.',
  'Show the individual assets': 'عرض الأصول الفردية',
  'Reconciled Totals ({currency})': 'الإجماليات المسوّاة ({currency})',
  'Page {page} of {pages} ({total} groups)': 'الصفحة {page} من {pages} ({total} مجموعة)',
  Previous: 'السابق',
  Next: 'التالي',
  'Assets in {group}': 'الأصول في {group}',
  'Search asset tag or name': 'ابحث برمز الأصل أو اسمه',
  'Search assets': 'البحث في الأصول',
  Close: 'إغلاق',
  'Asset Tag': 'رمز الأصل',
  Asset: 'الأصل',
  Movement: 'الحركة',
  'Opening Cost ({currency})': 'التكلفة الافتتاحية ({currency})',
  'Additions ({currency})': 'الإضافات ({currency})',
  'Disposals ({currency})': 'الاستبعادات ({currency})',
  'Closing Cost ({currency})': 'التكلفة الختامية ({currency})',
  'Closing Accum ({currency})': 'المتراكم الختامي ({currency})',
  'Period Dep. ({currency})': 'إهلاك الفترة ({currency})',
  Added: 'مضاف',
  Disposed: 'مستبعد',
  Transferred: 'محوَّل',
  Impairment: 'انخفاض القيمة',
  '{n} components': '{n} مكونات',
  '{name}: cost {cost}, carrying {carrying}, {months} months': '{name}: التكلفة {cost}، القيمة الدفترية {carrying}، {months} شهرًا',
  ', disposed {date}': '، استُبعد في {date}',
  'No assets match.': 'لا توجد أصول مطابقة.',
  '{n} assets': '{n} أصول',
  '{n} asset': '{n} أصل',
  'Shown in {currency}.': 'معروض بعملة {currency}.',
  'Balances at the period-end rate; depreciation and impairment of the period at the average rate':
    'الأرصدة بسعر نهاية الفترة؛ وإهلاك الفترة وانخفاض قيمتها بالسعر المتوسط',
  'Rates used:': 'الأسعار المستخدمة:',
  '1 {currency} = {closingRate} {groupCurrency} at period end ({closingDate}), {averageRate} average':
    '1 {currency} = {closingRate} {groupCurrency} في نهاية الفترة ({closingDate})، و{averageRate} متوسطًا',
  ' (no average rate entered - period-end rate used)': ' (لم يُدخل سعر متوسط - استُخدم سعر نهاية الفترة)',
  'Exception lines': 'بنود الاستثناءات',
  Source: 'المصدر',
  Reference: 'المرجع',
  Description: 'الوصف',
  'Difference ({currency})': 'الفرق ({currency})',
  'Reconciliation Check:': 'فحص التسوية:',
  'Loading...': 'جارٍ التحميل...',
  'No closed period selected.': 'لم يتم اختيار فترة مغلقة.',
  'SLA: Balanced': 'اتفاقية الخدمة: متوازن',
  'Exceptions: {n}': 'الاستثناءات: {n}',

  // Executive hub
  'Valuation by Category': 'التقييم حسب الفئة',
  'Cost Basis': 'أساس التكلفة',
  'Period Deprec': 'إهلاك الفترة',
  'Net Book': 'صافي الدفترية',
  'IAS 16': 'IAS 16',
  'Run posted': 'تم ترحيل التشغيل',
  'Manage →': 'إدارة ←',
  'USALI Allocated': 'موزَّع حسب USALI',
  '≥ 90% SLA': '≥ 90% من اتفاقية الخدمة',
  '< 90% SLA': '< 90% من اتفاقية الخدمة',
  'Shown in {currency}: balances at the closing rate, depreciation and spend at the average rate ({rates}).':
    'معروض بعملة {currency}: الأرصدة بسعر الإقفال، والإهلاك والإنفاق بالسعر المتوسط ({rates}).',
  ', no average rate - closing rate used': '، لا يوجد سعر متوسط - استُخدم سعر الإقفال',

  // Operations & finance panels
  'Property operations': 'عمليات العقار',
  'Shown in {currency} ({rates}).': 'معروض بعملة {currency} ({rates}).',
  ', closing rate used for the month': '، استُخدم سعر الإقفال للشهر',
  'Open exceptions by value': 'الاستثناءات المفتوحة حسب القيمة',
  'No open exceptions. Completed audits with missing, mislocated or damaged items appear here.':
    'لا توجد استثناءات مفتوحة. تظهر هنا عمليات الجرد المكتملة التي تتضمن بنودًا مفقودة أو في غير موقعها أو تالفة.',
  'Open the exception queue': 'فتح قائمة الاستثناءات',
  'Largest:': 'الأكبر:',
  'Under-par items': 'أصناف دون المستوى المعياري',
  'Short {units} units ({value})': 'نقص {units} وحدة ({value})',
  'Every pooled item is at or above par.': 'كل صنف مجمّع عند المستوى المعياري أو أعلى منه.',
  'Manage par levels': 'إدارة المستويات المعيارية',
  'Overdue issues': 'عُهد متأخرة',
  'No issued item is past its due-back date.': 'لا يوجد صنف مسلَّم تجاوز تاريخ إرجاعه.',
  'Open custody moves': 'فتح حركات العهدة',
  '{n} d': '{n} يوم',
  'Repair-or-Replace queue': 'قائمة الإصلاح أو الاستبدال',
  'No asset has reached the Repair-or-Replace signal.': 'لم يصل أي أصل إلى مؤشر الإصلاح أو الاستبدال.',
  'Review in the repairs workbench': 'المراجعة في منضدة الإصلاحات',
  'poor x2': 'سيئ مرتين',
  'Warranty expiries (next {days} days)': 'انتهاء الضمانات (خلال {days} يومًا القادمة)',
  'No warranty expires in the next 60 days.': 'لا ينتهي أي ضمان خلال الـ 60 يومًا القادمة.',
  'Finance this month': 'المالية لهذا الشهر',
  'Finance month': 'الشهر المالي',
  Additions: 'الإضافات',
  'No capitalised additions in this month.': 'لا توجد إضافات مرسملة في هذا الشهر.',
  'Plus capitalised repairs': 'بالإضافة إلى الإصلاحات المرسملة',
  Disposals: 'الاستبعادات',
  'NBV {value}': 'صافي القيمة الدفترية {value}',
  'No approved disposals in this month.': 'لا توجد استبعادات معتمدة في هذا الشهر.',
  'Open disposals': 'فتح الاستبعادات',
  'Cost retired': 'التكلفة المستبعدة',
  Proceeds: 'العائدات',
  'Gain / (loss)': 'الربح / (الخسارة)',
  'Unposted items': 'بنود غير مرحَّلة',
  'Everything for this month is posted.': 'تم ترحيل كل شيء لهذا الشهر.',
  'Open depreciation runs': 'فتح عمليات تشغيل الإهلاك',
  'Draft depreciation runs': 'مسودات تشغيل الإهلاك',
  'Properties without a posted run': 'عقارات بلا تشغيل مرحَّل',
  'Disposals awaiting approval': 'استبعادات بانتظار الاعتماد',
  '{n} run exceptions to review': '{n} استثناءات تشغيل للمراجعة',
  '{n} property transfer between currencies need an FX rate': '{n} تحويل عقاري بين عملات يحتاج إلى سعر صرف',
  '{n} property transfers between currencies need an FX rate': '{n} تحويلات عقارية بين عملات تحتاج إلى سعر صرف',

  // Capex forecast
  'What needs replacing now and over the next two years, from end-of-life dates, the repair-or-replace queue and condition grades.':
    'ما يلزم استبداله الآن وخلال العامين القادمين، استنادًا إلى تواريخ انتهاء العمر وقائمة الإصلاح أو الاستبدال ودرجات الحالة.',
  'Capex forecast exported as {filename}.': 'تم تصدير توقعات النفقات الرأسمالية باسم {filename}.',
  Property: 'العقار',
  'All properties': 'جميع العقارات',
  'Loading forecast...': 'جارٍ تحميل التوقعات...',
  'Needed now': 'مطلوب الآن',
  'Next 4 quarters (planned)': 'الأرباع الأربعة القادمة (مخطط)',
  'Next 8 quarters (planned)': 'الأرباع الثمانية القادمة (مخطط)',
  'Total forecast': 'إجمالي التوقعات',
  'Flagged repair-or-replace': 'مُعلَّم للإصلاح أو الاستبدال',
  'Graded poor or out of service': 'مصنَّف سيئًا أو خارج الخدمة',
  'Past expected life': 'تجاوز العمر المتوقع',
  'Planned end-of-life replacements': 'الاستبدالات المخططة عند نهاية العمر',
  Quarter: 'الربع',
  Assets: 'الأصول',
  Amount: 'المبلغ',
  'Report text': 'نص التقرير',
  'Draft a narrative': 'صياغة نص سردي',

  // Lifecycle forecast
  Category: 'الفئة',
  Department: 'القسم',
  'mixed currencies': 'عملات مختلطة',
  'Assets reaching the end of their expected life in each of the next eight quarters, with the cost to replace them.':
    'الأصول التي تبلغ نهاية عمرها المتوقع في كل ربع من الأرباع الثمانية القادمة، مع تكلفة استبدالها.',
  'Lifecycle forecast exported as {filename}.': 'تم تصدير توقعات دورة الحياة باسم {filename}.',
  'Group by': 'التجميع حسب',
  'Replacement cost, next 8 quarters and overdue:': 'تكلفة الاستبدال للأرباع الثمانية القادمة والمتأخرة:',
  'Assets:': 'الأصول:',
  'Already past expected life:': 'تجاوزت العمر المتوقع بالفعل:',
  '{n} assets have no expected life (no Book, Catalogue life or Book Policy life) and are not counted.':
    '{n} أصول ليس لها عمر متوقع (لا دفتر ولا عمر في الكتالوج ولا عمر في سياسة الدفتر) ولم تُحتسب.',
  "No asset reaches the end of its expected life in the next eight quarters. Expected life comes from the asset's Book, its Catalogue Item or its category's Book Policy.":
    'لا يبلغ أي أصل نهاية عمره المتوقع خلال الأرباع الثمانية القادمة. يُستمد العمر المتوقع من دفتر الأصل أو صنفه في الكتالوج أو سياسة الدفتر لفئته.',
  Overdue: 'متأخر',
  Total: 'الإجمالي',
  'Assets in the forecast ({n})': 'الأصول في التوقعات ({n})',
  'End of life': 'نهاية العمر',
  'Life from': 'مصدر العمر',
  'Replacement cost': 'تكلفة الاستبدال',
  'Cost from': 'مصدر التكلفة',
  'Overdue ({period})': 'متأخر ({period})',
  'Book (remaining life)': 'الدفتر (العمر المتبقي)',
  'Book Policy': 'سياسة الدفتر',
  Catalogue: 'الكتالوج',
  'Catalogue replacement cost': 'تكلفة الاستبدال في الكتالوج',
  'Catalogue standard cost': 'التكلفة القياسية في الكتالوج',
  'Asset replacement cost': 'تكلفة استبدال الأصل',
  'Purchase cost (estimate)': 'تكلفة الشراء (تقديرية)',
  None: 'لا يوجد',

  // Loss & breakage
  Reason: 'السبب',
  Item: 'الصنف',
  'Stock point': 'نقطة المخزون',
  'Loss & Breakage Report': 'تقرير الفقد والكسر',
  'Breakage and loss of pooled stock and written-off tagged assets, with value, by item, stock point, department or reason.':
    'كسر وفقد المخزون المجمّع والأصول الموسومة المشطوبة، مع القيمة، حسب الصنف أو نقطة المخزون أو القسم أو السبب.',
  'Loss & breakage report exported as {filename}.': 'تم تصدير تقرير الفقد والكسر باسم {filename}.',
  From: 'من',
  To: 'إلى',
  'All reasons': 'جميع الأسباب',
  'All departments': 'جميع الأقسام',
  'All stock points': 'جميع نقاط المخزون',
  'Pooled stock and tagged assets': 'المخزون المجمّع والأصول الموسومة',
  'Pooled stock only': 'المخزون المجمّع فقط',
  'Tagged assets only': 'الأصول الموسومة فقط',
  Search: 'بحث',
  'Reference or item': 'المرجع أو الصنف',
  'Clear filters': 'مسح عوامل التصفية',
  'Shown in {currency}, each loss at the average rate of its month ({rates}).': 'معروض بعملة {currency}، وكل خسارة بالسعر المتوسط لشهرها ({rates}).',
  Events: 'الأحداث',
  Units: 'الوحدات',
  Value: 'القيمة',
  'No losses or breakage match these filters. Breakage is logged from the blind counts console; written-off tagged assets come from approved disposals.':
    'لا توجد خسائر أو كسر مطابقة لعوامل التصفية هذه. يُسجَّل الكسر من وحدة العد الأعمى، وتأتي الأصول الموسومة المشطوبة من الاستبعادات المعتمدة.',
  Share: 'الحصة',
  Date: 'التاريخ',
  Qty: 'الكمية',
  'Page {page} of {pages} ({total} events)': 'الصفحة {page} من {pages} ({total} حدث)',

  // OE cost per occupied room
  'Room nights must be a whole number': 'يجب أن تكون الليالي الفندقية عددًا صحيحًا',
  'Occupied room nights saved for {period}.': 'تم حفظ ليالي الغرف المشغولة لفترة {period}.',
  '{n} month of occupied room nights imported ({layout} file).': 'تم استيراد {n} شهر من ليالي الغرف المشغولة (ملف {layout}).',
  '{n} months of occupied room nights imported ({layout} file).': 'تم استيراد {n} أشهر من ليالي الغرف المشغولة (ملف {layout}).',
  'Operating Equipment Cost per Occupied Room': 'تكلفة معدات التشغيل لكل غرفة مشغولة',
  'Breakage and losses, OE replacements and OE amortisation divided by occupied room nights, by month and property.':
    'الكسر والخسائر واستبدالات معدات التشغيل وإطفاؤها مقسومة على ليالي الغرف المشغولة، حسب الشهر والعقار.',
  'Report exported as {filename}.': 'تم تصدير التقرير باسم {filename}.',
  'Occupancy year': 'سنة الإشغال',
  'Cost per occupied room ({from} to {to})': 'التكلفة لكل غرفة مشغولة ({from} إلى {to})',
  'Cost per occupied room:': 'التكلفة لكل غرفة مشغولة:',
  'OE cost {cost} · {nights} room nights': 'تكلفة معدات التشغيل {cost} · {nights} ليلة غرفة',
  '{n} months have no occupancy yet': '{n} أشهر بلا إشغال حتى الآن',
  Month: 'الشهر',
  'Breakage & losses': 'الكسر والخسائر',
  'OE replacements': 'استبدالات معدات التشغيل',
  'OE amortisation': 'إطفاء معدات التشغيل',
  'Room nights': 'ليالي الغرف',
  'Per occupied room': 'لكل غرفة مشغولة',
  'not entered': 'غير مُدخل',
  'Occupied room nights {year}': 'ليالي الغرف المشغولة {year}',
  "Enter the month's occupied room nights from the night audit, or import the PMS export below. Press Enter or leave the box to save.":
    'أدخل ليالي الغرف المشغولة للشهر من التدقيق الليلي، أو استورد ملف التصدير من نظام إدارة الفندق أدناه. اضغط Enter أو غادر الحقل للحفظ.',
  '{property} {period} occupied room nights': 'ليالي الغرف المشغولة {property} {period}',
  Imported: 'مستورد',
  Entered: 'مُدخل',
  ' by {user}': ' بواسطة {user}',
  'Import from the PMS (CSV)': 'الاستيراد من نظام إدارة الفندق (CSV)',
  'Monthly file:': 'ملف شهري:',
  'Daily file:': 'ملف يومي:',
  '(summed per month).': '(بالمجموع لكل شهر).',
  'Add a': 'أضف عمود',
  'column to import several properties at once; otherwise choose the property above. Nothing is saved if any row is wrong.':
    'لاستيراد عدة عقارات دفعة واحدة؛ وإلا فاختر العقار أعلاه. لا يُحفظ أي شيء إذا كان أي صف غير صحيح.',
  'Occupancy CSV file': 'ملف CSV للإشغال',
  'Occupancy CSV text': 'نص CSV للإشغال',
  Import: 'استيراد',
};
